import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingBookingButton from "@/components/FloatingBookingButton";
import WhatsAppButton from "@/components/WhatsAppButton";
import CookieConsent from "@/components/CookieConsent";
import PageTransition from "@/components/PageTransition";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AssetOverridesProvider } from "@/hooks/useAssetOverrides";

import Index from "./pages/Index";
import About from "./pages/About";
import Apartments from "./pages/Apartments";
import HeraApartment from "./pages/HeraApartment";
import ZeusApartment from "./pages/ZeusApartment";
import Destinations from "./pages/Destinations";
import Reviews from "./pages/Reviews";
import Booking from "./pages/Booking";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./components/admin/AdminLayout";
import AdminEnquiries from "./pages/admin/AdminEnquiries";
import AdminBookings from "./pages/admin/AdminBookings";
import AdminSeasons from "./pages/admin/AdminSeasons";
import AdminCoupons from "./pages/admin/AdminCoupons";
import AdminPhotos from "./pages/admin/AdminPhotos";
import AdminRevenue from "./pages/admin/AdminRevenue";

const queryClient = new QueryClient();

function PublicLayout() {
  return (
    <>
      <Navbar />
      <main id="main-content">
        <PageTransition>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/about" element={<About />} />
            <Route path="/apartments" element={<Apartments />} />
            <Route path="/apartments/hera" element={<HeraApartment />} />
            <Route path="/apartments/zeus" element={<ZeusApartment />} />
            <Route path="/destinations" element={<Destinations />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </PageTransition>
      </main>
      <Footer />
      <FloatingBookingButton />
      <WhatsAppButton />
      <CookieConsent />
    </>
  );
}

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <LanguageProvider>
        <AssetOverridesProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Navigate to="/admin/enquiries" replace />} />
                <Route path="enquiries" element={<AdminEnquiries />} />
                <Route path="bookings" element={<AdminBookings />} />
                <Route path="seasons" element={<AdminSeasons />} />
                <Route path="coupons" element={<AdminCoupons />} />
                <Route path="photos" element={<AdminPhotos />} />
                <Route path="revenue" element={<AdminRevenue />} />
              </Route>
              <Route path="/*" element={<PublicLayout />} />
            </Routes>
          </BrowserRouter>
        </AssetOverridesProvider>
      </LanguageProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
